import { Configuration } from "@seriously-rad/seriouslyrad-framework-core/Configuration";
import { EntityCommandTypeEnum } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { WindowShim } from "@seriously-rad/seriouslyrad-framework-core/RadWindow";
import { registerPageManagerConfiguration } from "@seriously-rad/seriouslyrad-framework-core/Registration";
import { nameof } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/Extensions";
import { PropertyEditorNew } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/PropertyEditorNew";
import { Schedule } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/Schedule";
import { EntityCommandJobEngineInstanceStart } from "./EntityCommands/EntityCommandJobEngineInstanceStart";
import { EntityCommandJobEngineInstanceStop } from "./EntityCommands/EntityCommandJobEngineInstanceStop";
import { EntityCommandJobScheduleRunNow } from "./EntityCommands/EntityCommandJobScheduleRunNow";
import { JobSchedule } from "./Server/Schema/Entities/JobSchedule.Generated";
import pageManagerConfiguration from "./Ui/PageManagerConfiguration";

const
    radWindow = WindowShim();

export async function registerModuleJobsAsync(configuration: Configuration)
{
    radWindow.entityManager?.removeCommand({
        type: EntityCommandTypeEnum.entitySet,
        entityName: "JobEngineInstance",
        key: "NEW"
    });
    radWindow.entityManager?.removeCommand({
        type: EntityCommandTypeEnum.entity,
        entityName: "JobEngineInstance",
        key: "OPEN"
    });
    radWindow.entityManager?.removeCommand({
        type: EntityCommandTypeEnum.entity,
        entityName: "JobEngineInstance",
        key: "DELETE"
    });

    radWindow.entityManager?.registerCommand(new EntityCommandJobEngineInstanceStart());
    radWindow.entityManager?.registerCommand(new EntityCommandJobEngineInstanceStop());
    radWindow.entityManager?.registerCommand(new EntityCommandJobScheduleRunNow());

    PropertyEditorNew.registerEditorControlOverride(propertyInfo =>
    {
        if (propertyInfo.typeInfo?.name === JobSchedule.name)
        {
            switch (propertyInfo.name)
            {
                case nameof(JobSchedule, "schedule"):
                    return new Schedule();
            }
        }

        return undefined;
    });

    registerPageManagerConfiguration(configuration, pageManagerConfiguration);
}